<template>
	<Col>
		<v-menu
			rounded="lg"
			v-model="showMenu"
			origin="center bottom"
			transition="slide-y-transition"
			:close-on-content-click="false"
			:nudge-right="nudgeRight || 40"
			:nudge-bottom="nudgeBottom || 35"
			content-class="select-favorite-apps-menu"
		>
			<template v-slot:activator="{ on, attrs, value }">
				<div v-on="on" v-bind="attrs">
					<slot v-bind:value="value" name="activator" />
				</div>
			</template>
			<Col class="menu-content overflow-y-auto height-100 pt-5 pb-2 px-3">
				<Row class="flex-align-center mb-1 pl-5 pr-[9px] justify-between">
					<Row class="items-center">
						<h5 class="accordion-title">{{ title }}</h5>
						<component :class="titleSuffixComponent.class" :is="titleSuffixComponent.component" v-if="titleSuffixComponent?.component" />
					</Row>
					<Row class="items-center">
						<div class="mr-[6px]">
							<AppTooltip v-if="createNewConfig" :disabled="!createNewConfig.tooltipText" :text="createNewConfig.tooltipText">
								<Col @click.native.stop="createNewConfig.createNew" class="create-new-button flex-centerize">
									<SIcon name="create-new-placement-plus" />
								</Col>
							</AppTooltip>
						</div>
						<PinButton :tooltipPosition="'top'" @click.native="pinNotifications" :isPinned="false" tooltipText="Pin" />
					</Row>
				</Row>
				<NavigationAccordionContent
					:to="to"
					:sections="sections"
					:settings="settings"
					@item-clicked="showMenu = false"
					:additionalItemSuffix="additionalItemSuffix"
				/>
			</Col>
		</v-menu>
	</Col>
</template>
<script>
import NavigationAccordionContent from './NavigationAccordionContent';
import PinButton from '@/components/ProjectMenu/PinButton.vue';
import { setIsNotificationsPinned } from '@/store/modules/appLayout/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
export default {
	name: 'CollapsedNavigationAccordionMenu',
	components: { PinButton, NavigationAccordionContent },
	props: {
		to: { type: Function },
		title: { type: String },
		sections: { type: Array },
		settings: { type: Object },
		nudgeRight: { type: Number },
		nudgeBottom: { type: Number },
		createNewConfig: { type: Object },
		additionalItemSuffix: { type: Object },
		titleSuffixComponent: { type: Object, default: () => ({}) },
	},
	methods: {
		...mapActionsShorthand({ setIsNotificationsPinned }),
		pinNotifications() {
			this.setIsNotificationsPinned({ isPinned: true });
		},
	},
	data() {
		return { showMenu: false };
	},
};
</script>
<style lang="scss" scoped>
.accordion-title {
	color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
	font-size: 13px;
	font-weight: 400;
}
.menu-content {
	width: 290px;
	max-height: 400px;
	border-radius: 6px;
	background: #ffffff;
	border: 1px solid #dfdfe2;
	box-shadow: 0px 3px 6px #00000029;
}
.create-new-button {
	height: 14px;
	width: 14px;
	cursor: pointer;
	border-radius: 50%;
	&.active,
	&:hover {
		background: #f2f2f2;
		border: 1px solid var(--border-color);
	}
}
</style>
